module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-collector-2.1dd81739.svg";